export default __webpack_public_path__ + "7cfff9592dba2f95733774dbed65925e.svg";